import { render, staticRenderFns } from "./KnowledgeUseData.vue?vue&type=template&id=b3d7b8c4&scoped=true"
import script from "./KnowledgeUseData.vue?vue&type=script&lang=js"
export * from "./KnowledgeUseData.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeUseData.vue?vue&type=style&index=0&id=b3d7b8c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d7b8c4",
  null
  
)

export default component.exports